import {
	createState,
} from './simpleDataList';

import {
	loadSitemapsRangeViaApi,
} from '~/model/sitemaps';



export const {
	loadData,
	reducer,
	selector,
} = createState(
	'inaccessibleSitemaps',
	(websiteId) => loadSitemapsRangeViaApi(websiteId, {
		'fields': 'url,status_code',
		'filter[is_inaccessible]': true,
		'offset': 0,
		'limit': 1000,
	}),
	30,
);
